import jQuery from 'jquery';
(function ($) {
    const $disabledLinks = $('a[disabled], a.disabled');

    if ($disabledLinks.length) {
        $disabledLinks.each(function () {
            $(this).on('click', function (e) {
                e.preventDefault();
            });
        });
    }
})(jQuery);
